module.exports = ".align-buttons {\n  text-align: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-update-technician-report/master-update-technician-report.component.scss
// module id = ./src/app/master/master-update-technician-report/master-update-technician-report.component.scss
// module chunks = main